<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col">
        <!-- Full Name -->
        <div class="flex items-center mt-2">
          <label class="font-bold text-gray-700">Full Name:</label>
          <span class="ml-2">{{ form.fullname }}</span>
        </div>
        <!-- Email -->
        <div class="flex items-center mt-2">
          <label class="font-bold text-gray-700">Email:</label>
          <span class="ml-2">{{ form.email }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'User',

  // Form Data
  data() {
    return {
      form: {
        fullname: '',
        email: ''
      }
    }
  },

  /* Form Validate */
  computed: {
    ...mapState('auth', ['userInfo'])
  },

  async mounted() {
    this.form.fullname = `${this.userInfo.first_name  } ${  this.userInfo.last_name}`
    this.form.email = this.userInfo.email
  }
}
</script>

<style scoped>
/* Add any custom styles for the text here */
</style>
